import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const CustomSelect = ({
  options,
  onChange,
  defaultValue,
  value,
  placeholder = "Select option",
  isSearchable = false,
  blockDropdown = false,
  onMenuOpen,
  onMenuClose,
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth <= 768); // Mobile breakpoint
    };

    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  // Close menu when blockDropdown becomes true
  useEffect(() => {
    if (blockDropdown && isMobile) {
      setMenuIsOpen(false);
    }
  }, [blockDropdown, isMobile]);

  const handleMouseEnter = () => {
    if (!isMobile) {
      setMenuIsOpen(true);
    }
  };

  const handleMouseLeave = () => {
    if (!isMobile) {
      setMenuIsOpen(false);
    }
  };

  const handleMenuOpen = () => {
    // Call parent's onMenuOpen callback if provided
    if (onMenuOpen) {
      onMenuOpen();
    }
  };

  const handleMenuClose = () => {
    // Call parent's onMenuClose callback if provided
    if (onMenuClose) {
      onMenuClose();
    }
  };

  return (
    <div
      className="react-select-hover-wrapper"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div style={{ position: "relative" }}>
        <Select
          options={options}
          formatOptionLabel={(options, { context }) => (
            <div className="d-flex justify-content-between align-center">
              <span className="provider-name text-wrap">{options.label}</span>
              {context === "menu" && options.num && (
                <span className="counter">{options.num}</span>
              )}
            </div>
          )}
          value={value}
          onChange={onChange}
          defaultValue={defaultValue}
          placeholder={placeholder}
          isSearchable={isSearchable}
          classNamePrefix="react-select"
          className="custom-select-casino"
          menuIsOpen={
            isMobile ? (blockDropdown ? false : undefined) : menuIsOpen
          }
          onMenuOpen={handleMenuOpen}
          onMenuClose={handleMenuClose}
        />
      </div>
    </div>
  );
};

CustomSelect.propTypes = {
  options: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.object,
  defaultValue: PropTypes.object,
  placeholder: PropTypes.string,
  isSearchable: PropTypes.bool,
  blockDropdown: PropTypes.bool,
  onMenuOpen: PropTypes.func,
  onMenuClose: PropTypes.func,
};

export default CustomSelect;
